import React from 'react';
import _ from 'lodash';
import { ReactComponent as LoadingLight } from '../../../assets/svg/loading-light.svg';

class ButtonNew extends React.Component {
	render() {
		return (
			<button
				className={
					'sl-button-new' +
					(_.has(this.props, 'isDisabled') && this.props.isDisabled ? ' disabled' : '')
				}
				onClick={() => {
					if (_.has(this.props, 'isDisabled') && this.props.isDisabled === true) {
					} else {
						this.props.handleClick();
					}
				}}
			>
				{_.has(this.props, 'isLoading') && this.props.isLoading === true ? (
					<LoadingLight />
				) : _.has(this.props, 'highlitedTitle') ? (
					<>
						{this.props.title}{' '}
						<span className="sl-button-highlighted-text">
							{this.props.highlitedTitle}
						</span>
					</>
				) : (
					this.props.title
				)}
			</button>
		);
	}
}

export default ButtonNew;
